export default "__VITE_ASSET__os09HMlP__"